<app-dialog-container class="contract-list-modal">
  <div class="modal-header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 mat-dialog-title fxLayout="row" fxLayoutAlign="center center">
      <mat-icon class="header-icon">description</mat-icon>
      {{ title }}
    </h2>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
      <button 
        *ngIf="showUpdateAllButton"
        mat-stroked-button color="primary"
        (click)="updateAllContractsStatus()"
        [matTooltip]="isSingleContractMode ? 'Atualizar contrato' : 'Atualizar todos os contratos'" fxLayout="row"
        fxLayoutAlign="center center" fxLayoutGap="6px">
        <mat-icon>refresh</mat-icon>
        {{ isSingleContractMode ? 'Atualizar' : 'Atualizar Tudo' }}
      </button>
      <button 
        *ngIf="showNewContractButton"
        mat-raised-button class="new-contract-button"
        (click)="generateNewContract()" fxLayout="row"
        fxLayoutAlign="center center" fxLayoutGap="6px">
        <mat-icon>add</mat-icon>
        NOVO CONTRATO
      </button>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div mat-dialog-content class="modal-content">
    <ng-container *ngIf="contracts$ | async as contracts">
      <div *ngIf="contracts.length === 0" class="no-contracts" fxLayout="column"
        fxLayoutAlign="center center">
        <mat-icon>folder_open</mat-icon>
        <p>Nenhum contrato encontrado para este cliente</p>
      </div>

      <div class="contracts-container" *ngIf="contracts.length > 0">
        <div fxLayout="row wrap" fxLayoutGap="24px grid"
          fxLayoutAlign="start start">
          <div *ngFor="let contract of contracts"
            [fxFlex]="isSingleContractMode ? '100%' : '33.33%'"
            [fxFlex.lt-md]="isSingleContractMode ? '100%' : '50%'"
            fxFlex.lt-sm="100%"
            class="contract-card-wrapper">
            <mat-card class="contract-card">
              <mat-card-content>
                <div class="status-section" fxLayout="row"
                  fxLayoutAlign="start center">
                  <span class="status-badge"
                    [class]="getStatusClass(contract.status, contract)"
                    fxLayout="row"
                    fxLayoutAlign="center center" fxLayoutGap="6px">
                    <mat-icon
                      *ngIf="contract.status === 'processing'">refresh</mat-icon>
                    <mat-icon
                      *ngIf="contract.status === 'waiting_for_signatories'">people</mat-icon>
                    <mat-icon
                      *ngIf="contract.status === 'waiting_for_signatures'">draw</mat-icon>
                    <mat-icon
                      *ngIf="contract.status === 'link_opened'">visibility</mat-icon>
                    <mat-icon
                      *ngIf="contract.status === 'signed'">check_circle</mat-icon>
                    <mat-icon
                      *ngIf="contract.status === 'archived'">archive</mat-icon>
                    <mat-icon
                      *ngIf="contract.status === 'canceled'">cancel</mat-icon>
                    <mat-icon
                      *ngIf="contract.status === 'editing'">edit</mat-icon>
                    {{ getStatusLabel(contract.status, contract) }}
                  </span>
                </div>

                <div class="contract-info" fxLayout="column" fxLayoutGap="8px">
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <strong>Código:</strong>
                    <span>{{ contract.id }}</span>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <strong>Última atualização:</strong>
                    <span>{{ contract.updatedAt | date:'dd/MM/yyyy HH:mm'
                      }}</span>
                  </div>
                </div>

                <div class="signatures-section">
                  <div fxLayout="column" fxLayoutGap="8px">
                    <h4 class="signature-title" fxLayout="row"
                      fxLayoutAlign="start center" fxLayoutGap="8px">
                      <mat-icon>people</mat-icon>
                      Assinaturas
                    </h4>
                    <div class="signatures-container">
                      <mat-list class="signatures-list" dense>
                        <mat-list-item
                          *ngFor="let signature of contract.signatures"
                          class="signature-item">
                          <div fxFlex fxLayout="row"
                            fxLayoutAlign="space-between center"
                            fxLayoutGap="8px">
                            <div fxFlex="60%" fxLayout="column"
                              fxLayoutGap="4px">
                              <div class="signature-name">{{ signature.name
                                }}</div>
                              <div class="signature-email">{{ signature.email
                                }}</div>
                              <div class="signature-role"
                                *ngIf="signature.role">
                                {{ signature.role }}
                              </div>
                              <div class="signature-phone"
                                *ngIf="signature.whatsAppNumber">
                                <span>{{ signature.whatsAppNumber }}</span>
                              </div>
                            </div>
                            <div fxFlex="40" fxLayout="column"
                              fxLayoutAlign="center center" fxLayoutGap="4px">
                              <span class="status-badge" [ngClass]="{
                                'status-signed': signature.status === 'signed',
                                'status-viewed': signature.status === 'waiting_for_signatures' || signature.status === 'link_opened',
                                'status-waiting': signature.status === 'waiting_for_signatories',
                                'status-canceled': signature.status === 'canceled'
                              }" fxLayout="row" fxLayoutAlign="center center"
                                fxLayoutGap="4px">
                                <mat-icon>
                                  {{
                                  signature.status === 'signed' ? 'check_circle'
                                  :
                                  signature.status === 'waiting_for_signatures'
                                  ||
                                  signature.status === 'link_opened' ?
                                  'visibility' :
                                  signature.status === 'canceled' ? 'cancel' :
                                  'schedule'
                                  }}
                                </mat-icon>
                                {{
                                signature.status === 'signed' ? 'Assinado' :
                                signature.status === 'waiting_for_signatures' ||
                                signature.status === 'link_opened' ?
                                'Visualizado'
                                :
                                signature.status === 'canceled' ? 'Rejeitado' :
                                'Aguardando'
                                }}
                                <span class="signed-date"
                                  *ngIf="signature.status === 'signed' && signature.signedAt">
                                  ({{ signature.signedAt | date:
                                  'dd/MM/yyyy HH:mm' }})
                                </span>
                              </span>
                              <button mat-icon-button color="primary"
                                *ngIf="signature.signUrl && signature.status !== 'signed' && signature.status !== 'canceled'"
                                (click)="copySignUrl(signature.signUrl, signature.name)"
                                matTooltip="Copiar link de assinatura de {{signature.name}}"
                                class="copy-link-button">
                                Copiar Link
                              </button>
                            </div>
                          </div>
                        </mat-list-item>
                      </mat-list>
                    </div>
                  </div>
                </div>
              </mat-card-content>

              <mat-card-actions align="end" fxLayout="row"
                fxLayoutAlign="end center" fxLayoutGap="8px">
                <button mat-stroked-button color="warn"
                  *ngIf="contract.status === 'waiting_for_signatures'"
                  (click)="removeContract(contract.id)"
                  matTooltip="Cancelar contrato" fxLayout="row"
                  fxLayoutAlign="center center" fxLayoutGap="6px">
                  <mat-icon>cancel</mat-icon>
                  Cancelar
                </button>

                <button mat-stroked-button color="primary"
                  *ngIf="contract.status === 'processing' || contract.status === 'waiting_for_signatories'"
                  (click)="resendContractEmails(contract.id)"
                  matTooltip="Reenviar emails de assinatura para todos os signatários"
                  fxLayout="row"
                  fxLayoutAlign="center center" fxLayoutGap="6px">
                  <mat-icon>send</mat-icon>
                  Reenviar
                </button>

                <button mat-stroked-button color="accent"
                  *ngIf="contract.status === 'processing' || contract.status === 'waiting_for_signatories' || contract.status === 'waiting_for_signatures'"
                  (click)="sendContractWhatsapp(contract)"
                  matTooltip="Enviar link de assinatura via WhatsApp"
                  fxLayout="row" fxLayoutAlign="center center"
                  fxLayoutGap="6px">
                  <mat-icon>whatsapp</mat-icon>
                  WhatsApp
                </button>

                <button mat-stroked-button color="warn"
                  *ngIf="contract.status !== 'waiting_for_signatures' && contract.status !== 'signed'"
                  (click)="removeContract(contract.id)"
                  matTooltip="Remover contrato" fxLayout="row"
                  fxLayoutAlign="center center" fxLayoutGap="6px">
                  <mat-icon>delete</mat-icon>
                  Remover
                </button>

                <button mat-raised-button class="download-button"
                  *ngIf="contract.status === 'signed' || contract.status === 'archived'"
                  [disabled]="isDownloading"
                  (click)="downloadContract(contract.id)"
                  matTooltip="Baixar contrato" fxLayout="row"
                  fxLayoutAlign="center center" fxLayoutGap="6px">
                  <mat-icon>download</mat-icon>
                  {{ isDownloading ? 'BAIXANDO...' : 'Baixar' }}
                </button>

                <button mat-stroked-button color="primary"
                  (click)="viewContract(contract.id)"
                  matTooltip="Visualizar contrato" fxLayout="row"
                  fxLayoutAlign="center center" fxLayoutGap="6px">
                  <mat-icon>visibility</mat-icon>
                  Ver
                </button>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</app-dialog-container>